import React, { useState } from "react";
import "./Navbar.css";
import { Link } from "react-scroll";
import { RiCloseLine } from "react-icons/ri";
import { AiOutlineBars } from "react-icons/ai";

const Navbar = () => {
  const [show, setShow] = useState(false);

  const handleToggle = () => {
    setShow(!show);
  };
  return (
    <nav className="Navbar">
      <menu>
        <ul id={show ? "nav-mobile" : "nav-mobile-hide"}>
          <li>
            <Link
              spy={true}
              smooth={true}
              duration={2000}
              className="nav-item"
              to="home"
            >
              home
            </Link>
          </li>
          <li>
            <Link
              spy={true}
              smooth={true}
              duration={2000}
              offset={10}
              className="nav-item"
              to="about"
            >
              about me
            </Link>
          </li>
          <li>
            <Link
              spy={true}
              smooth={true}
              duration={2000}
              offset={-50}
              className="nav-item"
              to="skill"
            >
              skill
            </Link>
          </li>
          <li>
            <Link
              spy={true}
              smooth={true}
              duration={2000}
              offset={-70}
              className="nav-item"
              to="portfolio"
            >
              portfolio
            </Link>
          </li>
          <li>
            <Link
              spy={true}
              smooth={true}
              duration={2000}
              offset={-30}
              className="nav-item"
              to="contact"
            >
              contact me
            </Link>
          </li>
        </ul>
      </menu>
      <div className="menu-icon" onClick={handleToggle}>
        {show ? (
          <RiCloseLine color="red" size={33} />
        ) : (
          <AiOutlineBars color="blue" size={33} />
        )}
      </div>
    </nav>
  );
};

export default Navbar;
